import { Container, Row, Col, Accordion } from 'react-bootstrap';
import FAQItem from '../components/FAQItem.js';
import { useState, useEffect } from "react";

function FAQ({ content: customContent }) {

    const [content, setContent] = useState(null);

    useEffect(() => {
        if (!customContent) {
            fetch("/data/content.json")
                .then((res) => res.json())
                .then((data) => setContent(data))
                .catch((error) => console.error("Error loading JSON:", error));
        } else {
            setContent(customContent);
        }
    }, [customContent]);

    if (!content || !content.faq) return <div></div>;

    const { faq } = content;

    return (
        <Container fluid id='faq' className='faq p-md-5'>
            <Row className='p-md-5 p-3 justify-content-center'>
                <Col lg={8}>
                    <h3 className='text-center'>{faq.title}</h3>

                    <Accordion defaultActiveKey="0" className='p-md-3'>
                        {faq.questions.map((item, index) => (
                            <FAQItem key={item.answer} item={item} index={index} />
                        ))}
                    </Accordion>
                </Col>
            </Row>
        </Container>
    );
}

export default FAQ;